declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../models/api_response_model';
import { ApiRequestModel } from '../../../models/api_request_model';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../services/hcp.service';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, SavePurchaseOrderRequest, PurchaseOrderItemRequest, MaterialHistoryController, GetMaterialHistoryRequest, GenericProcPostRequest, S_Methods, DoctorAppointmentsByDoctorcode2Contoller, SavePatientVisitRequest, AppointmentCancelRequest, DoctorAppointmentsByDoctorCode2Request, AppointmentDetailsByAppointmentCodeController, AppointmentDetailsByAppointmentCodeRequest, } from '../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../models/actor/actor';
import { ActorService } from '../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../models/master/mastermodel';
import { FDService } from '../../../services/fd.service';
import { ConsultantMapPipe, PatientListPipe2 } from '../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { Time } from '@angular/common';

@Component({
  selector: 'sel_apptdetails',
  templateUrl: './sel_apptdetails.modal.html',
  styleUrls: ['./sel_apptdetails.modal.scss']
})

export class NgbSel_ApptdetailsModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  @Input() AppointmentStatus: string;
  @Input() CurrentDoctorAppointmentsByDoctorcode2Contoller: DoctorAppointmentsByDoctorcode2Contoller;
  @Input() AppointmentCode: any;
  @Input() PatientName: string;
  @Input() Age: string;
  @Input() Gender: string;
  @Input() Telephone1: string;
  @Input() Email: string;
  @Input() AppointmentDate: any;
  @Input() PatientFormattedCode: any;

  @Input() xLocationCode: any;
  @Input() ProviderCode: any;
  @Input() FromDate: any;

  SelectedFromDate: NgbDateStruct;

  CurrentSavePatientVisitInformationRequest: SavePatientVisitRequest;
  CurrentAppointmentCancelRequest: AppointmentCancelRequest;
  //@Input() VendorName: string;
  //@Input() VendorCode: number;
  //public TotalOrderQuantity: number;
  //public Tax: any
  TodayDate = new Date();
  isRequesting: boolean;
    ApiResData: any;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private filter1: PatientListPipe2,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    //alert(this.PatientFormattedCode);
    //alert(this.AppointmentCode);
    this.SelectedFromDate = { year: this.FromDate.getFullYear(), month: this.FromDate.getMonth() + 1, day: this.FromDate.getDate() };
    this.LoadDoctorAppointmentsByDoctor();
    this.CurrentSavePatientVisitInformationRequest = new SavePatientVisitRequest();
    this.CurrentSavePatientVisitInformationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentAppointmentCancelRequest = new AppointmentCancelRequest();
    this.CurrentAppointmentCancelRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }
  public isLoading: boolean = false;
  CurrentDoctorAppointmentsByDoctorcodeController: DoctorAppointmentsByDoctorcode2Contoller[];
  CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest: DoctorAppointmentsByDoctorCode2Request;
  SelectedAppointmentDetailsByAppointmentCodeController: AppointmentDetailsByAppointmentCodeController[];
  SelectedAppointmentDetails: AppointmentDetailsByAppointmentCodeController;
  LoadDoctorAppointmentsByDoctor() {
      this.CurrentDoctorAppointmentsByDoctorcodeController = new Array<DoctorAppointmentsByDoctorcode2Contoller>();
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest = new DoctorAppointmentsByDoctorCode2Request();
      this.pdata1 = this.GetSelectedDateAppts();
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 15;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel.xLocationCode = this.xLocationCode;
      this._GetDoctorAppointmentsByDoctorcodeContoller();
  }
  _GetDoctorAppointmentsByDoctorcodeContoller() {
    this.isLoading = true;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.ProviderCode;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 15;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel.xLocationCode = this.xLocationCode;
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller2(this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentDoctorAppointmentsByDoctorcodeController = this.ApiResData.Result;
          this.pdata1 = this.GetSelectedDateAppts();                
          this.isLoading = false;
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }
      );
  }

  pdata1: DoctorAppointmentsByDoctorcode2Contoller[];
  listFilter1: string;
  ngOnChanges1(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata1 = this.GetSelectedDateAppts();

    this.criteriaChange1(this.listFilter1);
  }
  criteriaChange1(value: any) {
    if (this.filter1 != null) {
      if (value != '[object Event]') {
        this.listFilter1 = value;
        //alert(this.listFilter);
        this.pdata1 = this.filter1.transform(this.GetSelectedDateAppts(), this.listFilter1);
      }
    }
  }


  GetSelectedDateAppts() {
    if (this.CurrentDoctorAppointmentsByDoctorcodeController.length > 0) {
      return this.CurrentDoctorAppointmentsByDoctorcodeController.
        filter(x => this.isSelectedPatient(x.AppointmentCode));// .getFullYear == d);
      //.getFullYear() == this.SelectedFromDate.year &&
      //  x.AppointmentDate.getDay() == this.SelectedFromDate.day &&
      //  x.AppointmentDate.getMonth()+1 == this.SelectedFromDate.month)
    }
    return [];
  }
  isSelectedPatient(da: any): boolean {
    var obj = this.AppointmentCode;
    if (obj == da) 
    {
      return true;
    }
    else {
      return false;
    }
  }
  isSelectedDate(da: any): boolean {
    var obj = new Date(da);
    var monthNo = this.SelectedFromDate.month;
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    if (obj.getFullYear() == this.SelectedFromDate.year &&
      obj.getMonth() + 1 == this.SelectedFromDate.month &&
      obj.getDate() == this.SelectedFromDate.day) {
      return true;
    }
    else {
      return false;
    }
  }

  onSubmit(l: DoctorAppointmentsByDoctorcode2Contoller, statusText: string, e) {

    var statusVal = e.target.checked;
    this.CurrentSavePatientVisitInformationRequest.ConditionalOperator = 10;
    this.CurrentSavePatientVisitInformationRequest.ActionItem = statusText;
    this.CurrentSavePatientVisitInformationRequest.ActionEvent = statusVal;

    this.CurrentSavePatientVisitInformationRequest.ActorCode = l.ActorCode;
    this.CurrentSavePatientVisitInformationRequest.ChekInTime = new Date();
    this.CurrentSavePatientVisitInformationRequest.AppointmentCode = l.AppointmentCode;
    this.CurrentSavePatientVisitInformationRequest.AppointmentTime = new Date(l.AppointmentDate).toLocaleTimeString();
    this.CurrentSavePatientVisitInformationRequest.CheckOutTime = new Date();
    this.CurrentSavePatientVisitInformationRequest.EncounterStartTime = new Date();
    this.CurrentSavePatientVisitInformationRequest.EncounterEndTime = new Date();
    this.CurrentSavePatientVisitInformationRequest.VisitCode = l.PatientVisit;
    this.CurrentSavePatientVisitInformationRequest.ProviderSwapped = l.ProviderSwapped;
    this.CurrentSavePatientVisitInformationRequest.ProviderCode = l.ProviderCode;
    this.CurrentSavePatientVisitInformationRequest.AppointmentStatus = l.AppointmentStatus;

    this.actorservice.SavePatientVisitInformation(this.CurrentSavePatientVisitInformationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          if (this.ApiResData.Result > 0) {
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadDoctorAppointmentsByDoctor();
            //this.LoadAppointmentDetailsByAppointmentCode(this.SelectedAppointmentDetails.AppointmentCode);
            //this.GetAppointmentDetailsByAppointmentCodeContoller();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }
      );
  }

  Profile(l: DoctorAppointmentsByDoctorcode2Contoller) {
    this.router.navigate(['healins/profileview', { FormattedCode: l.PatientFormattedCode, DisplayName: l.PatientName, title: "App" }]);
    this.activeModal.close();
  }
  Addbill(l: DoctorAppointmentsByDoctorcode2Contoller) {
    this.router.navigate(['healins/receiptold', { FormattedCode: l.PatientFormattedCode }]);
    this.activeModal.close();
  }

  cancel() {
    swal({
      title: 'Do You Want To Cancel Appoinment?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {

      this.CancelAppoinment();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  CancelAppoinment() {
    console.log('..................');
    //  this.StartRefreshing();
    this.CurrentAppointmentCancelRequest.ConditionalOperator = 15;
    this.CurrentAppointmentCancelRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentAppointmentCancelRequest.AppointmentCode = this.CurrentDoctorAppointmentsByDoctorcode2Contoller.AppointmentCode;

    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveAppointmentInformation2(this.CurrentAppointmentCancelRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this._GetDoctorAppointmentsByDoctorcodeContoller();
            this.activeModal.close();
            //this._GetProviderAvlSlotsContoller();
            //this.Load
            //this.LoadScansData();
            //this.LoadOvaryData();
            //this.LoadTestData();
            //this.LoadMedicineData();
            //this.ShowList = true;
            //this.LoadMedicineData();
            // this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );


  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
